import React from 'react'
import { PageContent, Heading, Image, Text } from 'components/library'
import img01 from './assets/Toren_SemiClose_2@2x.jpg'
import './Aspect03.css'

class Aspect03 extends React.Component {

  render() {
    return (
      <div className="Chapter05-Aspect03">
        <PageContent nospacing>
          <div className="has-two-col">
            <div className="col-01">
              <div>
                <Heading h2>…je moet overschakelen</Heading>
                <Text>Als je een sleepbeweging uitvoert dien je te allen tijde het kanaal van Apron Control uit te luisteren en te reageren op oproepen van Apron Control. Alleen op aangeven van Apron Control mag je overschakelen naar Apron-Noord, Apron-Zuid of naar LVNL. Na een baankruising schakel je echter wel zelf weer terug van LVNL naar Apron Control, er zijn echter een aantal baankruisingen waarbij dit niet het geval is. Vraag aan je instructeur om welke baankruisingen dit gaat.</Text>
              </div>
              <div>
                <Heading h2>…de verbinding uitvalt</Heading>
                <Text>Indien de verbinding met Apron Control of LVNL uitvalt voer je de volgende stappen uit:</Text>
                <ul>
                  <li>Je verlaat met je trekker en sleepobject de baankruising, zodat de baankruising vrij is.</li>
                  <li>Je gaat op zoek naar andere vormen van communicatie, bijv. een ander kanaal of mobiele telefoon.</li>
                  <li>Je blijft wachten tot Apron Control of LVNL de situatie opmerkt en maatregelen neemt.</li>
                </ul>
              </div>
            </div>
            <div className="col-02">
              <Image src={img01}/>
            </div>
          </div>
        </PageContent>
      </div>
    )
  }
}

export default Aspect03



// WEBPACK FOOTER //
// ./src/content/chapters/05/03/Aspect03.js